import { useState } from "react";
import AuthShell, { Field, Input, AuthLink } from "@/saas/components/AuthShell";
import SButton from "@/saas/components/SButton";
import { useI18n } from "@/saas/i18n";

export default function Forgot() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // Phase 1: UI only — simulate success
    setSent(true);
  };

  return (
    <AuthShell
      title={t("auth.forgot.title")}
      subtitle={t("auth.forgot.subtitle")}
      footer={
        <p className="text-sm text-white/60">
          <AuthLink to="/login">← {t("auth.back_to_login")}</AuthLink>
        </p>
      }
    >
      {sent ? (
        <div className="p-5 rounded-md border border-gold/30 bg-gold/5" data-testid="forgot-success">
          <div className="flex items-center gap-2 text-gold font-semibold mb-1">✓ {t("auth.forgot.sent")}</div>
          <div className="text-sm text-white/60 break-all">{email}</div>
        </div>
      ) : (
        <form className="space-y-5" onSubmit={submit} data-testid="forgot-form">
          <Field label={t("auth.field.email")}>
            <Input
              type="email" required autoComplete="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
            />
          </Field>
          <SButton type="submit" size="lg" className="w-full" data-testid="forgot-submit">
            {t("auth.submit.forgot")}
          </SButton>
        </form>
      )}
    </AuthShell>
  );
}
